import { useEffect, useRef } from "react";
import BlogPosts from "./Blog/blogposts_short.json";
import { useNavigate, useParams } from "react-router-dom";

// Resolves where a legacy blog-post URL should land: the first
// video-details link in the post body becomes its /preview/ page,
// anything else goes home. Returns undefined when a multi-link post has
// no video link — the pre-#691 behaviour was to render nothing and stay
// put, and that is preserved.
const resolveRedirectTarget = (slug) => {
  let postContent;

  BlogPosts.forEach(function (arrItem) {
    if (slug === arrItem.slug) {
      postContent = arrItem.content.replace(/<[^>]*>?/gm, "");
    }
  });

  var matches = postContent.match(/\bhttps?:\/\/\S+/gi);
  if (matches) {
    if (matches.length > 1) {
      // The LAST video-details link wins. (The pre-#691 code pushed a
      // navigation for every match — its comment said "first" but the
      // forEach never broke, so the final push was where visitors landed;
      // 3 of the 116 posts have differing first/last links, so "last" is
      // the behaviour-preserving choice, now as a single push.)
      let target;
      matches.forEach(function (mat) {
        if (mat.includes("video-details")) {
          var cleanMat = mat.replace(/[{()}]/g, "");
          var matSlug = cleanMat.split("/video-details/")[1];
          target = "/preview/" + matSlug + "-preview";
        }
      });
      return target;
    } else if (matches.length === 1) {
      if (matches[0].includes("video-details")) {
        var cleanMatch = matches[0].replace(/[{()}]/g, "");
        var matSlug = cleanMatch.split("/video-details/")[1];
        return "/preview/" + matSlug + "-preview";
      } else {
        return "/";
      }
    } else {
      return "/";
    }
  } else {
    return "/";
  }
};

const Post = () => {
  const navigate = useNavigate();
  const { id: slug } = useParams();

  const target = resolveRedirectTarget(slug);

  // Navigating is a side effect — render-body calls double-fire under
  // StrictMode's dev double-render; the ref keeps the push once-only
  // (#691, same pattern as LoggedInLayout).
  const redirected = useRef(false);
  useEffect(() => {
    if (target !== undefined && !redirected.current) {
      redirected.current = true;
      navigate(target);
    }
  }, [target, navigate]);

  return null;
};

export default Post;
